import { useQuery } from '@tanstack/react-query';
import { api } from 'utils';

function fetchRecentSubmissions({ queryKey }: any) {
  const [, , params] = queryKey;

  return api().get('/apis/history/', {
    params: { page: params.page, limit: params.rows },
  });
}

export function useRecentSubmissionsQuery(params: { page: number; rows: number }) {
  return useQuery(
    ['list-zero', 'recent-submissions', params],
    fetchRecentSubmissions,
    {
      keepPreviousData: true,
      select: (response) => ({
        list: response?.data?.data || [],
        total: response?.data?.total || 0,
      }),
    }
  );
}
